import React from 'react'
import './PersonAppointment.css'
import {
  Select,
  Input,
  Icon,
  Button,
  Form,
  DatePicker,
  Modal,
  message,
  Upload,
  Spin
} from 'antd'
import request from '@/utils/request'
// import Cookies from 'js-cookie' // js-cookie
import { setKey, getKey,removeToken } from '@/utils/Cookie'
import axios from 'axios'
import PersonImg from '@/img/person.png'
import showImg from '@/img/showGo.png'
import moment from 'moment'
const FormItem = Form.Item
const { RangePicker } = DatePicker
const { Option } = Select
var myCaptchaPerson = null
class PersonAppointmentForm extends React.Component {
  state = {
    IndexKey: null, //当前天数索引值
    currentIndex: null, //选择样式
    visible: false, //显示新增预约
    tid: null, //选择日期
    TimeArray: [], //时间
    TimeArrayData: [], //时间票数
    OrderList: [], //我的订单数据

    picShow: null,
    picFile: null,

    UnSendArrayList: [],
    facilityMarking: null,
    optionData: null,
    showtime: null,
    submitState: false,
    isVilLoading:false,
    dataObjContent:null,
    imgId:null,
  }
  componentDidMount() {
    if(!getKey('SCMT-ADMIN-TOKEN')){
      removeToken();
      window.location.href='http://piao.scstm.com/';
    }
    document.documentElement.scrollTop = document.body.scrollTop = 0

    // var that = this
    // // eslint-disable-next-line
    // request
    // .post(
    //   '/v1/user/mobile/reserve/personalEx',
    //   that.state.optionData
    // )
    // .then(res => {
    //   // console.log('个人预约')
    //   // console.log(res)
    //   that.setState({ submitState: false })
    //   if (res.message == '预约成功！') {
    //     setKey('teamSuccess', 1)
    //     that.props.history.push('/Main/Home/ShowAppointment')
    //   } else {
    //     setKey('MessageFiald', JSON.stringify(res))
    //     that.props.history.push('/Main/Home/ShowAppointmentFaild')
    //   }
    // })
    // .catch(function(error) {
    //   that.setState({ submitState: false })
    //   console.log(error)
    // })    
    // myCaptchaPerson = _dx.Captcha(document.getElementById('c1'), {
    //   style: 'popup',
    //   appId: 'ebaf330bfcdb7ac9b10a42b9a8e4a474', //appId，在控制台中“应用管理”或“应用配置”模块获取
    //   success: function(token) {
    //     // console.log('token:', token)
    //     myCaptchaPerson.hide()
    //     myCaptchaPerson.reload()
    //     if(!token ){
    //       Modal.warning({
    //         title: '提示',
    //         content: '验证码错误！'
    //       })
    //         return;
    //     }
    //     that.setState({ submitState: true })
    //     that.state.optionData.append('appId',token);
    //     console.log(that.state.optionData)
    //     request
    //       .post(
    //         '/v1/user/mobile/reserve/personalEx',
    //         that.state.optionData
    //       )
    //       .then(res => {
    //         // console.log('个人预约')
    //         // console.log(res)
    //         that.setState({ submitState: false })
    //         if (res.message == '预约成功！') {
    //           setKey('teamSuccess', 1)
    //           that.props.history.push('/Main/Home/ShowAppointment')
    //         } else {
    //           setKey('MessageFiald', JSON.stringify(res))
    //           that.props.history.push('/Main/Home/ShowAppointmentFaild')
    //         }
    //       })
    //       .catch(function(error) {
    //         that.setState({ submitState: false })
    //         console.log(error)
    //       })
    //   },
    //   fail: function(msg) {
    //     // console.log('token:', msg)
    //   }
    // })
  }
  componentWillMount() {
    this.getDates()
  }

  //获得当前时间票数
  getTime() {
    request
      .get('/v1/mobile/ticket/info?type=2', {
        withCredentials: true
      })
      .then(res => {
        // console.log('res')
        // console.log(res)
        // console.log(this.state.TimeArray)
        const ArrayData = res
         for (var i = 0; i < this.state.IndexKey; i++) {
           ArrayData.unshift({})
         }
        // console.log(ArrayData)
        this.setState({
          TimeArrayData: ArrayData
        })
      })
  }
  //时间数据改变
  ChangeTime(date) {
    const year = date.split('/')[0]
    const month = date.split('/')[1]
    const day = date.split('/')[2]
    const monthText = Number(month) < 10 ? `0${month}` : month
    const dayText = Number(day) < 10 ? `0${day}` : day
    return `${year}-${monthText}-${dayText}`
  }
  /* 获得当前时间所在的周日期*/
  getDates() {
    var that = this
    var curDate = new Date()
    var ThisTime = new Date(curDate.setDate(curDate.getDate() + 0))
    var timesStamp = ThisTime.getTime()
    var currenDay = ThisTime.getDay()
    var dates = []
    var days = []

    for (var i = 0; i < 7; i++) {
      dates.push(
        that.ChangeTime(
          new Date(
            timesStamp + 24 * 60 * 60 * 1000 * (i - ((currenDay + 6) % 7))
          )
            .toLocaleDateString()
            .replace(/[年月]/g, '/')
            .replace(/[日上下午]/g, '/')
        )
      )
    }
    for (var i = 0; i < 8; i++) {
      days.push(
        that.ChangeTime(
          new Date(timesStamp + 24 * 60 * 60 * 1000 * i)
            .toLocaleDateString()
            .replace(/[年月]/g, '/')
            .replace(/[日上下午]/g, '/')
        )
      )
    }

    var lastTime = new Date(curDate.setDate(curDate.getDate() + 14))
    // console.log(dates)
    // console.log(days)
    var arr = dates.concat(days) //合并数组
    var arrNew = Array.from(new Set(arr)) //通过set集合去重
    // console.log(arrNew)
    this.setState({
      IndexKey: dates.indexOf(days[0]),
      TimeArray: arrNew
    })
    this.getTime()
    this.getDataInfo()
  }
  GetPerson() {
    this.props.history.push('/Main/Home/ShowAppointment')
  }

  //控制添加模态框
  showModal = () => {
    if (this.state.UnSendArrayList && this.state.UnSendArrayList.length > `4`) {
      Modal.warning({
        title: '提示',
        content: '每次最多添加1人！'
      })
      return
    }
    if (this.state.tid) {
      this.setState({
        visible: true
      })
      this.occupy()
    } else {
      this.warning()
    }
  
  }
  handleOk = e => {
    // console.log(e)
    this.setState({
      visible: false
    })
  }

  handleCancel = e => {
    // console.log(e)
    this.setState({
      visible: false
    })
  }
  CloseCirData = index => {
    const NewArray = this.state.UnSendArrayList
    NewArray.splice(index, 1)
    this.setState({
      UnSendArrayList: NewArray
    })
  }
  getDataInfo(){
    var that = this
    request
    .get('/v1/news?code=1')
    .then(res => {
       console.log('res')
      const data = res
      console.log(data)
      this.setState({
        dataObjContent: data
      })
    })
  }
  //确定预约
  sendData() {
    // console.log(this.state.UnSendArrayList)
    console.log(this.imgId)
    if (this.state.UnSendArrayList && this.state.UnSendArrayList.length > 0) {
      //目前一人只能提交一个数据信息
      if(this.state.UnSendArrayList.length >1){

      }
      let formData = new FormData()
      this.state.UnSendArrayList.map((item, index) => {
        // console.log(item.file)
        formData.append(`idCard_${index}`, item.idCard)
        formData.append(`name_${index}`, item.name)
        formData.append(`facilityMarking_${index}`, item.facilityMarking)
        formData.append(`tid_${index}`, item.tid)
        formData.append(`pic_${index}`, item.file)
        
      })
      formData.append(`imgId`, this.imgId)
      // console.log(formData)
 //     myCaptchaPerson.reload()
 //     myCaptchaPerson.show()
      this.setState({
        optionData: formData
      })
      var that = this
      // eslint-disable-next-line
      request
      .post(
        '/v1/user/mobile/reserve/personalEx',
        that.state.optionData
      )
      .then(res => {
        // console.log('个人预约')
        // console.log(res)
        that.setState({ submitState: false })
        if (res.message == '预约成功！') {
          setKey('teamSuccess', 1)
          that.props.history.push('/Main/Home/ShowAppointment')
        } else {
          setKey('MessageFiald', JSON.stringify(res))
          that.props.history.push('/Main/Home/ShowAppointmentFaild')
        }
      })
      .catch(function(error) {
        that.setState({ submitState: false })
        console.log(error)
      })      
    } else {
      message.info('请先添加预约人！')
    }
  }
  //添加预约
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const obj = {}
        if(this.state.UnSendArrayList && this.state.UnSendArrayList.length > 0){
          Modal.warning({
            title: '提示',
            content: '每次只能添加1人！'
          })
          return ;
        }
        const array = this.state.UnSendArrayList
        obj.name = values.nickname
        obj.idCard = values.card
        obj.mobile = values.phone
        // obj.facilityMarking = Cookies.get('tourist_cookie_authentication')
        // obj.facilityMarking = getKey('tourist_cookie_authentication')
        obj.facilityMarking = getKey('facilityMarking')
        obj.tid = this.state.tid
        obj.timeName = this.state.showtime.time
        obj.img = this.state.picShow
        obj.file = this.state.picFile
        array.push(obj)
        this.setState({
          UnSendArrayList: array,
          visible: false,
          picShow: null
        })
        console.log(this.state.UnSendArrayList)

        this.props.form.resetFields()
      }
    })
  }
  occupy() {
      axios
      .post('/v1/mobile/reserve/occupy/'+this.state.tid+'/'+getKey('facilityMarking'), {
        withCredentials: true
      })
      .then(res => {
        if(res===0){
          Modal.warning({
            title: '提示',
            content: '无法添加更多人员，余票不足！'
          })
          this.setState({isOccupy:false})
        }else if(res>0){
          this.getTime();
          this.setState({isOccupy:true})
        
            this.setState({
              visible: true
            })
          
        }else if(res == -1){
          Modal.warning({
            title: '提示',
            content: '网络异常！'
          })
          this.setState({isOccupy:false})
        }else{
          Modal.warning({
            title: '提示',
            content: '操作过于频繁，请稍后再试！'
          })
          this.setState({isOccupy:false})
        }
      })
  }
  //选择样式
  setActive(data, index) {
    // console.log(data)
    // console.log(index)
    this.setState({
      currentIndex: index,
      tid: data.id,
      showtime: data
    })
  }
  //正则验证手机号
  checkPhoneNub(rule, value, callback) {
    var reguPhone = /^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/ //手机号码验证regEx:第一位数字必须是1，11位数字
    var rePhone = new RegExp(reguPhone)
    // console.log(rePhone.test(value))
    if (rePhone.test(value)) {
      callback()
    } else {
      callback('请输入正确的手机号！')
    }
  }
  //正则验证身份证
  checkIdCardNub(rule, value, callback) {
    var reguIdCar = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/ //身份证
    var reIdCar = new RegExp(reguIdCar)
    if (reIdCar.test(value)) {
      callback()
    } else {
      callback('请输入正确的身份证号！')
    }
  }
  //提示未选择时间
  warning() {
    Modal.warning({
      title: '提示',
      content: '请先选择预约具体时间！'
    })
  }
  //显示时间配置
  ShowDate(date) {
    const year = date.split('-')[0]
    const month = date.split('-')[1]
    const day = date.split('-')[2]
    return `${month}月${day}日`
  }
  transformFile = file => {
    /**
     * 针对图片进行压缩,如果图片大小超过压缩阈值,则执行压缩,否则不压缩
     */
    console.log(file);
    console.log("file" + file.name);
  //  let file = option.file;
    //判断是否是图片类型
    if (this.checkIsImage(file.name)) {
   //     const {compressThreshold = 5, isPictureCompress = false, pictureQuality = 0.92} = this.props;
       // let fileSize = file.size / 1024 / 1024;
         console.log('before compress, the file size is : ', file.size / 1024 / 1024 + "M");
        //当开启图片压缩且图片大小大于等于压缩阈值,进行压缩
       // if ((fileSize >= compressThreshold) && isPictureCompress) {
            //判断浏览器内核是否支持base64图片压缩
            // if (typeof (FileReader) === 'undefined') {
            //     return file;
            // } else {
              try {
                  this.setState({
                      spinLoading: true
                  });
                  return new Promise(resolve => {
                      //声明FileReader文件读取对象
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => {
                          // 生成canvas画布
                          const canvas = document.createElement('canvas');
                          // 生成img
                          const img = document.createElement('img');
                          img.src = reader.result;
                          img.onload = () => {
                              const ctx = canvas.getContext('2d');
                              //原始图片宽度、高度
                              let originImageWidth = img.width, originImageHeight = img.height;
                              console.log(originImageWidth)
                              console.log(originImageHeight)
                           //   alert("originImageWidth" + originImageWidth)
                         //     alert("originImageHeight" + originImageHeight)
                              //默认最大尺度的尺寸限制在（1920 * 1080）
                              // 指定大小
                              let maxWidth = 1920, maxHeight = 1080, ratio = 16 / 9;
                              //目标尺寸
                              let targetWidth = originImageWidth, targetHeight = originImageHeight;
                              //当图片的宽度或者高度大于指定的最大宽度或者最大高度时,进行缩放图片
                              if (originImageWidth > originImageHeight ) {
                                if(originImageWidth > maxWidth || originImageHeight > maxHeight){
                                    if ((originImageWidth / originImageHeight) > ratio) {
                                      //宽度取最大宽度值maxWidth,缩放高度
                                      targetWidth = maxWidth;
                                      targetHeight = Math.round(maxWidth * (originImageHeight / originImageWidth));
                                  } else {
                                      //高度取最大高度值maxHeight,缩放宽度
                                      targetHeight = maxHeight;
                                      targetWidth = Math.round(maxHeight * (originImageWidth / originImageHeight));
                                  }
                                }else{
                                  resolve (file);
                                }
                                  //超过最大宽高比例
                                
                              }else if(originImageWidth <= originImageHeight ){
                                if(originImageWidth >maxHeight  || originImageHeight > maxWidth){
                                    if ((originImageHeight / originImageWidth) > ratio) {
                                      //宽度取最大宽度值maxWidth,缩放高度
                                      targetHeight = maxWidth;
                                      targetWidth = Math.round(maxWidth * (  originImageWidth/originImageHeight ));
                                  } else {
                                      //高度取最大高度值maxHeight,缩放宽度
                                      targetWidth = maxHeight;
                                      targetHeight = Math.round(maxHeight * ( originImageHeight/originImageWidth ));
                                  }
                                }else{
                                  resolve (file);
                                  }
                              }else{
                                resolve (file);
                              }
                              // canvas对图片进行缩放
                              canvas.width = targetWidth;
                              canvas.height = targetHeight;
                              // 清除画布
                              ctx.clearRect(0, 0, targetWidth, targetHeight);
                              // 绘制图片
                              ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                              // quality值越小,图像越模糊,默认图片质量为0.92
                              const imageDataURL = canvas.toDataURL(file.type || 'image/jpeg', 1);
                              // 去掉URL的头,并转换为byte
                              const imageBytes = window.atob(imageDataURL.split(',')[1]);
                              // 处理异常,将ascii码小于0的转换为大于0
                              const arrayBuffer = new ArrayBuffer(imageBytes.length);
                              const uint8Array = new Uint8Array(arrayBuffer);
                              for (let i = 0; i < imageBytes.length; i++) {
                                  uint8Array[i] = imageBytes.charCodeAt(i);
                              }
                              let mimeType = imageDataURL.split(',')[0].match(/:(.*?);/)[1];
                              let newFile = new File([uint8Array], file.name, {type: mimeType || 'image/jpeg'});
                              // console.log('after compress, the file size is : ', (newFile.size / 1024 / 1024) + "M");
                              resolve(newFile);
                          };
                      };
                      reader.onerror = () => {
                          this.setState({
                              spinLoading: false
                          });
                          return file;
                      }
                  }).then(res => {
                      this.setState({
                          spinLoading: false
                      });
                      return res;
                  }).catch(() => {
                      this.setState({
                          spinLoading: false
                      });
                      return file;
                  });
              } catch (e) {
                  this.setState({
                      spinLoading: false
                  });
                  //压缩出错,直接返回原file对象
                  return file;
              }
          }
    //     } else {
    //         //不需要压缩，直接返回原file对象
    //         return file;
    //     }
    // } else {
    //     //非图片文件,不进行压缩,直接返回原file对象
    //     return file;
    // }
  }
  
  //检查是否为图片类型
  checkIsImage = (fileName) => {
    let flag;
    let imageTypeList = ['.jpg', '.png', '.jpeg', '.gif', '.GIF', '.JPG', '.PNG', '.JPEG'];
    for (let item of imageTypeList) {
        flag = fileName.indexOf(item) !== -1;
        if (flag) {
            return true;
        }
    }
    return flag;
  }
  //自定义上传
  customRequest = option => {
    // console.log(option)
    //生成一个图片路径(使用URL.createObjectURL将选择的图片生成一个路径)
    this.setState({isVilLoading:true})
    var imgSrc = URL.createObjectURL(option.file)
    // console.log(imgSrc)
    var img = new Image();
 
    // 改变图片的src
    img.src = imgSrc;
     
    // 加载完成执行
    img.onload = function(){
        // 打印
        console.log('width:'+img.width+',height:'+img.height);
    };
    let that =this;
    this.setState({
      picShow: imgSrc,
      picFile: null
    })
   
    let param = new FormData()
    param.append('file', option.file)
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    axios
      .post('http://piao.scstm.com/check/api/Image/FaceDetect', param, config)
   //     .post('http://192.168.20.128/check/api/Image/FaceDetect', param, config)
      .then(res => {
        console.log('团队预约')
        console.log(res)
        if (res && res.status == 0) {
          that.setState({
            picFile: option.file,
            isVil:true,
           
            isVilLoading:false
          })
          that.imgId=res.result.imgId;
        } else {
          that.setState({
            isVilLoading:false,
            isVil:false
          })
          message.error(res.errorMsg)
          return
        }
      })
      .catch(function(error) {
        that.setState({
          isVilLoading:false,
          isVil:false
        })
      })    
  }
  handlePreview() {}
  handleChange() {}
  //
  dateWeek(data) {
    //时间格式转换
    var newDate = this.dateToStr(new Date(data))
    //获取当天是星期几
    var ji = '日一二三四五六'.charAt(new Date(data).getDay())
    return `周${ji}`
  }
  dateToStr(datetime) {
    var year = datetime.getFullYear()
    var month = datetime.getMonth() + 1 //js从0开始取
    var date = datetime.getDate()
    var hour = datetime.getHours()
    var minutes = datetime.getMinutes()
    var second = datetime.getSeconds()
    if (month < 10) {
      month = '0' + month
    }
    if (date < 10) {
      date = '0' + date
    }
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (second < 10) {
      second = '0' + second
    }

    var time =
      year +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hour +
      ':' +
      minutes +
      ':' +
      second
    return time
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: '86'
    })(
      <Select style={{ width: 70 }}>
        <Option value="86">+86</Option>
        {/* <Option value="87">+87</Option> */}
      </Select>
    )
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 24,
          offset: 0
        }
      }
    }
    const {
      IndexKey,
      TimeArrayData,
      currentIndex,
      UnSendArrayList,
      dataObjContent
    } = this.state
    // console.log('UnSendArrayList')
    // console.log(UnSendArrayList)
    return (
      <div className="PersonAppointment">
        <Spin tip="资料正在上传请耐心等待..." spinning={this.state.submitState}>
          <div className="PersonAppointment_title">
            <span className="PersonAppointment_title_line"></span>
            <span className="PersonAppointment_title_text">选择时间</span>
          </div>
          <div className="PersonAppointment_time">
            <div className="PersonAppointment_time_header">
              <div className="item">星期一</div>
              <div className="item">星期二</div>
              <div className="item">星期三</div>
              <div className="item">星期四</div>
              <div className="item">星期五</div>
              <div className="item">星期六</div>
              <div className="item">星期日</div>
            </div>
            <div className="PersonAppointment_time_conten">
              {TimeArrayData.map((item, index) => {
                const start= moment(item.startResvTime)
                const stop= moment(item.stopTime)
                const now=moment()
                return (
                  
                  <div className="item" key={index}>
                    {IndexKey > index ? (
                      <div className="itemBox"></div>
                    ) : item.isOpen && item.isOpen == 1 && now.isAfter(start) && now.isBefore(stop)  ? (
                      item.remnantNum && item.remnantNum > 0 ? (
                        <div
                          onClick={el => this.setActive(item, index)}
                          className={`itemBox  ${
                            index === currentIndex ? 'itemActive' : null
                          }`}
                        >
                          <div className="num">{this.ShowDate(item.time)}</div>
                          <div className="time">余{item.remnantNum}票</div>
                        </div>
                      ) : (
                        <div className="itemBox itemAll">
                          <div className="num">{this.ShowDate(item.time)}</div>
                          <div className="numAll">约满</div>
                        </div>
                      )
                    ) :item.isOpen && item.isOpen == 1 && now.isBefore(start) ?(
                      <div className="itemBox itemAll">
                        <div className="num">{this.ShowDate(item.time)}</div>
                        <div className="numAll">暂未开放预约</div>
                      </div>
                    ): (
                      <div className="itemBox itemAll">
                        <div className="num">{this.ShowDate(item.time)}</div>
                        <div className="numAll">闭馆</div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
          <div className="PersonAppointment_title">
            <span className="PersonAppointment_title_line"></span>
            <span className="PersonAppointment_title_text">填写预约人资料</span>
          </div>
          <div className="PersonAppointment_AddConten">
            {UnSendArrayList.length > 0
              ? UnSendArrayList.map((item, index) => {
                  return (
                    <div className="item" key={index}>
                      <div className="item_left">
                        <div className="item_left_name">
                          <span className="name">{item.name}</span>
                          <span>{item.mobile}</span>
                        </div>
                        <div className="item_left_card">
                          <span className="card">身份证号：</span>
                          <span>{item.idCard}</span>
                        </div>
                        <div className="item_left_card">
                          <span className="card">预约时间：</span>
                          <span> {this.ShowDate(item.timeName)}</span>
                          <span> {this.dateWeek(item.timeName)}</span>
                        </div>
                      </div>
                      <div className="item_right">
                        <img src={item.img}></img>
                      </div>
                      <div
                        className="icon"
                        onClick={el => this.CloseCirData(index)}
                      >
                        <Icon type="close-circle" />
                      </div>
                    </div>
                  )
                })
              : 
            <div className="item AddData" onClick={el => this.showModal()}>
              <div className="AddText">
                <Icon type="plus-circle" />
                <span>添加预约人</span>
              </div>
            </div>
              }
          </div>
          <div className="PersonAppointment_footer">
            <div
              className="PersonAppointment_footer_button"
              onClick={el => this.sendData()}
            >
              立即预约
            </div>
          </div>
          <div className="ccc">
            <div id="c1" ref="myInput"></div>
          </div>
          <div className="instructions_content_row" dangerouslySetInnerHTML={{__html:dataObjContent}}>
          </div>

          <Modal
          bodyStyle={{style:"width: 20%"}}
            title="添加个人预约"
            width="703px"
            visible={this.state.visible}
            onOk={this.handleOk}
            footer={null}
            onCancel={this.handleCancel}
          >
            <Form {...formItemLayout} onSubmit={this.handleSubmit} >
              <Form.Item label={<span>姓名</span>}>
                {getFieldDecorator('nickname', {
                  rules: [
                    {
                      required: true,
                      message: '请输入姓名',
                      whitespace: true
                    }
                  ]
                })(<Input placeholder="请输入姓名" />)}
              </Form.Item>

              <Form.Item label="身份证号：">
                {getFieldDecorator('card', {
                  rules: [
                    { required: true, message: '身份证号不能为空！' },
                    { validator: this.checkIdCardNub }
                  ]
                })(<Input placeholder="请输入身份证号" />)}
              </Form.Item>
              <Form.Item label="上传预约人脸照片：">
                {getFieldDecorator('dragger', {
                  rules: [{ required: true, message: '人脸照片不能为空！' }]
                  // valuePropName: 'fileList',
                  // getValueFromEvent: this.normFile
                })(
                  <Upload.Dragger
                    name="files"
                    action=""
                    showUploadList={false}
                    transformFile={this.transformFile}
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                    customRequest={this.customRequest}
                  >
                  <Spin tip="等待验证" spinning={this.state.isVilLoading}>
                    <div className="ImgContent">
                      <div className="ContentImg">
                        {this.state.picShow ? (
                          <div
                            style={{
                              width: '224px',
                              height: '139px',
                              background: '#fafafa'
                            }}
                          >
                            <img
                              style={{  height: '139px' }}
                              src={this.state.picShow}
                            ></img>
                          </div>
                        ) : (
                          <div
                            style={{
                              width: '224px',
                              height: '139px',
                              background: '#fafafa'
                            }}
                          >
                            <p className="ant-upload-drag-icon">
                              <img
                                style={{
                                  width: '65px',
                                  height: '71px',
                                  marginTop: '14px'
                                }}
                                src={PersonImg}
                              ></img>
                            </p>
                            <p
                              className="ant-upload-text"
                              style={{ fontSize: '12px', color: '#666' }}
                            >
                              请上传预约人正面人脸照片
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="ContentRight">
                        <div
                          className="ant-upload-hint"
                          style={{ padding: '0' }}
                        >
                          请上传jpg、jpeg、png、gif的图片格式，图片大小不超过700kb。
                        </div>
                      </div>
                    </div>
                    </Spin>
                  </Upload.Dragger>
                )}
              </Form.Item>

              <Form.Item {...tailFormItemLayout}>
                {/* <Button type="primary" htmlType="submit">
                立即预约
              </Button> */}
                <div className="TeamAppointment_footer">
                  <Button
                    className="TeamAppointment_footer_button"
                    // onClick={el => this.GetPerson()}
                    htmlType="submit"
                  >
                    立即预约
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </Modal>
        </Spin>
      </div>
    )
  }
}
const PersonAppointment = Form.create()(PersonAppointmentForm)
export default PersonAppointment
